import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PlanCard } from './PlanCard';
import { SpotsCounter } from './SpotsCounter';
import { UrgencyBar } from './UrgencyBar';
import { UpsellModal } from './UpsellModal';
import { plans } from '../data/plans';
import { HERO_IMAGE } from '../data/images';
export function OrderBox() {
  const [selectedPlan, setSelectedPlan] = useState<'starter' | 'complete'>('complete');
  const [checkoutPlan, setCheckoutPlan] = useState<'starter' | 'complete' | null>(null);
  const starter = plans[0];
  const complete = plans[1];
  return <div className="order-box" data-id="element-25" data-mp="368zjo74lvgmh">
      <div className="flex flex-col items-center text-center" data-id="element-26" data-mp="367wuq4qufo97">
        <img src={HERO_IMAGE} alt="The Positive Parenting Mega Kit box filled with printable routine charts" width={1063} height={1500} loading="lazy" decoding="async" className="block h-auto w-full max-w-[294px]" style={{
        aspectRatio: '1063 / 1500',
        filter: 'drop-shadow(0 12px 16px rgba(20,17,15,0.16))'
      }} data-id="element-27" data-mp="3b7j9wjq8fekn" />

        <h2 className="mt-5 text-[26px] font-extrabold leading-[1.15] md:text-[34px]" data-id="element-28" data-mp="2w4qd17qwi1k4">
          <span className="block" data-id="element-29" data-mp="2s0sdivxnyoqj">The Calm Mornings</span>
          <span className="block" data-id="element-30" data-mp="2s3o94dm1h1bt">Mega Kit</span>
        </h2>

        <p className="mt-3 text-[12px] font-medium uppercase tracking-[0.14em] text-ink/55" data-id="element-31" data-mp="2n28p8ovll0v0">
          +13,369 downloads by mindful families
        </p>
      </div>

      <div role="radiogroup" aria-label="Choose your plan" className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 md:items-start md:gap-4" data-id="element-32" data-mp="2dcfhy02hn7wk">
        <div className="order-2 md:order-1" data-id="element-33" data-mp="24c958gem6byg">
          <PlanCard plan={starter} selected={selectedPlan === 'starter'} onSelect={() => setSelectedPlan('starter')} onCheckout={() => setCheckoutPlan('starter')} data-id="element-34" data-mp="24dagolzjl0gp" />
        </div>
        <div className="order-1 md:order-2" data-id="element-35" data-mp="1ug633ajridbi">
          <PlanCard plan={complete} recommended selected={selectedPlan === 'complete'} onSelect={() => setSelectedPlan('complete')} onCheckout={() => setCheckoutPlan('complete')} data-id="element-36" data-mp="1kq7lm1kvl5t6" />
        </div>
      </div>

      <div className="mt-6" data-id="element-37" data-mp="1fre3twyk2sn7">
        <SpotsCounter data-id="element-38" data-mp="1fqkzt3qzeh8r" />
      </div>

      <div className="mt-6" data-id="element-39" data-mp="1frmjtxpz6e2m">
        <UrgencyBar data-id="element-40" data-mp="23gyp4mi6m1zn" />
      </div>

      <div className="mt-4 text-center" data-id="element-41" data-mp="23i024wircyk0">
        <p className="flex items-center justify-center gap-1.5 text-[13px] text-ink/70" data-id="element-42" data-mp="23j1q21kvhfj5">
          <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 flex-none" data-id="element-43" data-mp="28f9ykw4keahc" />
          Instant access by email · Secure payment
        </p>
        <p className="mt-0.5 text-[12px] text-ink/55" data-id="element-44" data-mp="1ypyw3sc6o42f">
          100% digital — nothing will be shipped
        </p>
      </div>

      <UpsellModal planId={checkoutPlan} onClose={() => setCheckoutPlan(null)} data-id="element-45" data-mp="2mersfpwpwdxk" />
    </div>;
}